import { render, staticRenderFns } from "./list1.vue?vue&type=template&id=995f2c38&"
import script from "./list1.vue?vue&type=script&lang=js&"
export * from "./list1.vue?vue&type=script&lang=js&"
import style0 from "./list1.vue?vue&type=style&index=0&id=995f2c38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports